/**
 * `ModalBase` is a primitive: it is the unstyled, unopinionated Radix Dialog wrapper that
 * other arch-ui modals are built on. It must only be consumed from inside arch-ui.
 *
 * Applications should use `arch-ui/src/Modal` instead — it applies the responsive chrome
 * (fullscreen and bottom-to-top transition on small screens, fade, rounded borders and
 * outside padding on large ones) that every app modal is expected to have. Using
 * `ModalBase` directly re-derives that behaviour at the call site and silently drops the
 * transition, since `ModalBase.Root` defaults to `transition="none"`.
 */
import {
  ModalBaseCloseButton as CloseButton,
  ModalBaseContent as Content,
  ModalBaseFooter as Footer,
  ModalBaseHeader as Header,
  ModalBaseOverlay as Overlay,
  ModalBaseRoot as Root,
  ModalBaseSubTitle as SubTitle,
  ModalBaseTitle as Title,
} from './ModalBase';

export default {
  CloseButton,
  Content,
  Footer,
  Header,
  Overlay,
  Root,
  SubTitle,
  Title,
};
